/**
 * Devuelve el cliente activo según el path actual.
 *
 * Si la URL matchea /c/:slug/..., devuelve el card del cliente.
 * Si no, devuelve undefined (modo global / home).
 */
import { useRouterState } from "@tanstack/react-router";
import { findClient, type ClientCard } from "@/lib/clients";

export function useActiveClient(): ClientCard | undefined {
  const routerState = useRouterState();
  const pathname = routerState.location.pathname;
  const match = pathname.match(/^\/c\/([^/]+)/);
  if (!match) return undefined;
  return findClient(match[1]);
}
